export const environment = {
  production: true,
  // BASE_URL_IMPORT: 'http://localhost:8080',
  // BASE_URL_INITIAL_BALANCE: 'https://kastor-initial-balance-devel.herokuapp.com',
  // BASE_URL_REPORT: 'https://kastor-jsreport-staging.herokuapp.com/api/report',
  // BASE_URL_REPORTS: 'https://kastor-report-production.herokuapp.com',
  // BASE_URL_CRUD: 'https://kastor-crud-production.herokuapp.com',
  // BASE_URL_ACCOUNTING_ACCOUNT: 'https://kastor-accounting-production.herokuapp.com',
  // BASE_URL_BULK_UPLOAD: 'https://kastor-bulk-production.herokuapp.com',
  // BASE_URL_COMMON_EXPENSES: 'https://kastor-common-expenses-staging.herokuapp.com',
  // BASE_URL_SSO: 'https://kastor-proxy-production.herokuapp.com/auth',
  // BASE_URL_PUBLIC: 'https://kastor-public-production.herokuapp.com',
  // BASE_URL_WEBPAY: 'https://kastor-webpay-api-production.herokuapp.com',
  // BASE_URL_TCEL: 'https://copropietarios.kastorsoftware.cl',
  // BASE_URL_TCEL_KIUNGO: 'https://copropietarios.kiungo.cl',
  // BASE_URL_ALERT: 'https://kastor-alert-production.herokuapp.com',
  // REALM: 'tcel',
  // WEBPAY_MALL_KEY: 'mall_dos',
  // REALM_K3REM: 'production',
  // BASE_URL_K3REM: 'https://repositorio.kastor.cl/edificio_k3rem/ingresos/login/',
  // BASE_URL_API_K3REM: 'https://kastor-payroll-production.herokuapp.com',
  // BASE_URL_MESSAGE: 'https://kastor-message-production.herokuapp.com',
  // LOGO_TCEL: 'assets/img/Kastor-Eslogan-trazado.svg',
  // LOGO_KIUNGO: 'assets/img/Kiungo-Eslogan-trazado.svg',
  // LOGO_COMUNIDAD_KIUNGO: 'https://s3.amazonaws.com/kstk3/k3-img-system/comunidad-copropietarios.png',
  // LOGO_COMUNIDAD_TCEL: 'https://s3.amazonaws.com/kstk3/k3-img-system/comunidad-copropietarios.png',
  // KIUNGO_DOMAIN: 'kiungo.cl',
  // BASE_URL_TRANSLATION: 'https://kastor-translation-production.herokuapp.com',
  // BASE_URL_KHIPU: 'https://kastor-api-khipu-production.herokuapp.com',
  // BASE_URL_MERCADOPAGO: 'https://kastor-mercadopago-production.herokuapp.com',
  // S3_BASE_URL: 'https://s3.amazonaws.com/',
  // S3_BUCKET: 'kstk3',
  // SECRET: '5tMmoqr1aoq9oX7iMA91In8aWnZLtnkTOFZTkKlRkYS3azQArlVlzTZ921D038M9',
  BASE_URL_REPORTS: 'https://kastor-reports-legacy.kastorsoftware.cl',
  BASE_URL_CRUD: 'https://kastor-crud-legacy.kastorsoftware.cl',
  BASE_URL_ACCOUNTING_ACCOUNT: 'https://kastor-accounting-legacy.kastorsoftware.cl',
  BASE_URL_BULK_UPLOAD: 'https://kastor-bulk-legacy.kastorsoftware.cl',
  BASE_URL_SSO: 'https://kastor-proxy-legacy.kastorsoftware.cl/auth',
  BASE_URL_PUBLIC: 'https://kastor-public-legacy.kastorsoftware.cl',
  BASE_URL_WEBPAY: 'https://kastor-webpay-api-production.herokuapp.com',
  BASE_URL_TCEL: 'https://copropietarios.kastorsoftware.cl',
  BASE_URL_TCEL_KIUNGO: 'https://copropietarios.kiungo.cl',
  // BASE_URL_ALERT: 'https://kastor-alert-production.herokuapp.com',
  REALM: 'tcel',
  WEBPAY_MALL_KEY: 'mall_dos',
  REALM_K3REM: 'production',
  BASE_URL_K3REM: 'https://repositorio.kastor.cl/edificio_k3rem/ingresos/login/',
  BASE_URL_API_K3REM: 'https://kastor-payroll-legacy.kastorsoftware.cl',
  BASE_URL_MESSAGE: 'https://kastor-message-legacy.kastorsoftware.cl',
  LOGO_TCEL: 'assets/img/Kastor-Eslogan-trazado.svg',
  LOGO_KIUNGO: 'assets/img/Kiungo-Eslogan-trazado.svg',
  LOGO_COMUNIDAD_KIUNGO: 'https://s3.amazonaws.com/kstk3/k3-img-system/comunidad-copropietarios.png',
  LOGO_COMUNIDAD_TCEL: 'https://s3.amazonaws.com/kstk3/k3-img-system/comunidad-copropietarios.png',
  KIUNGO_DOMAIN: 'kiungo.cl',
  BASE_URL_TRANSLATION: 'https://kastor-translation-legacy.kastorsoftware.cl',
  BASE_URL_KHIPU: 'https://kastor-api-khipu-production.herokuapp.com',
  BASE_URL_MERCADOPAGO: 'https://kastor-mercadopago-production.herokuapp.com',
  S3_BASE_URL: 'https://s3.amazonaws.com/',
  S3_BUCKET: 'kstk3',
  SECRET: '5tMmoqr1aoq9oX7iMA91In8aWnZLtnkTOFZTkKlRkYS3azQArlVlzTZ921D038M9',
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts